
<div class="card">

  <div class="card-header">
    <h4 class="card-title">{{title | translate}}</h4>
    <div class="actions">
      <ul class="list-inline mb-0">
        <li>@if (showAddNew) {
          <button class="btn" (click)="addNew()"><i class="ft ft-plus"></i></button>
        }</li>
        <li>@if (editModeEnable) {
          <button class="btn" (click)="editSelected()" [disabled]="!selectedRow"><i class="ft ft-edit"></i></button>
        }</li>
        <li>@if (showDelete) {
          <button class="btn" (click)="deleteSelected()" [disabled]="!selectedRow || deleting"><i class="ft ft-trash"></i></button>
        }</li>
        <li>@if (showRefresh) {
          <button class="btn" (click)="refresh()"><i class="ft ft-refresh-cw"></i></button>
        }</li>
      </ul>
    </div>
  </div>

  <ng-content select="[filter]"></ng-content>

  <div class="card-content collapse show">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <ng-template *ngTemplateOutlet="headersTemplate.templateRef; context:{}"></ng-template>
          </tr>
        </thead>
        @if (items && items.length) {
          <tbody>
            @for (row of items; track row; let i = $index) {
              <tr
                [class.bg-info]="selectedRow === row"
                [class.white]="selectedRow === row"
                (click)="selectRow(row)"
                (dblclick)="rowDoubleCLicked(row)">
                <ng-template *ngTemplateOutlet="cellsTemplate.templateRef; context:{ row: row, index: (i + page * pageSize), page: page }"></ng-template>
              </tr>
            }
          </tbody>
        }
      </table>
      @if (!items || !items.length) {
        <div class="no-data">
          No data
        </div>
      }
    </div>
  </div>

  <div class="card-footer">
    <span class="float-right">
      <nz-pagination [nzPageIndex]="1" [nzTotal]="total" [nzPageSize]="pageSize" (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
    </span>
  </div>

</div>
